<template>
  <div class="call-quality">

    <div v-if="reports.length">

      <quality-report-metric
        v-if="currentLatency"
        :ref="reportType + '-latency'"
        :reportType="reportType"
        :metric="'latency'"
        :progress="progress"
        :measure="currentLatency"
        :aggregate="avgLatency"
        :threshold="600"
        :operator="'lt'"
      ></quality-report-metric>

      <quality-report-metric
        :ref="reportType + '-packets'"
        :reportType="reportType"
        :metric="'packets'"
        :progress="progress"
        :measure="currentPacketsReceived"
        :aggregate="percentagePacketsRecieved"
        :threshold="98"
        :operator="'gt'"
      ></quality-report-metric>

      <quality-report-metric
        v-if="reportType==='audio'"
        :ref="reportType + '-jitter'"
        :reportType="reportType"
        :metric="'jitter'"
        :progress="progress"
        :measure="currentJitter"
        :aggregate="avgJitter"
        :threshold="50"
        :operator="'lt'"
      ></quality-report-metric>

<!--      <quality-report-metric-->
<!--        v-if="reportType==='video' && config.user.browser.name === 'firefox'"-->
<!--        :ref="reportType + '-frameRate'"-->
<!--        :reportType="reportType"-->
<!--        :metric="'frameRate'"-->
<!--        :progress="progress"-->
<!--        :measure="currentFrameRate"-->
<!--        :aggregate="avgFrameRate"-->
<!--        :threshold="0"-->
<!--        :operator="'gt'"-->
<!--      ></quality-report-metric>-->

      <quality-report-metric
        v-if="reportType==='audio'"
        :ref="reportType + '-audioLevel'"
        :reportType="reportType"
        :metric="'audioLevel'"
        :progress="progress"
        :measure="audioLevelFallback"
        :aggregate="audioLevelFallback"
        :threshold="0"
        :operator="'gt'"
      ></quality-report-metric>
    </div>

    <div v-else>
      <p><i class="fa fa-spinner fa-spin"></i></p>
    </div>

  </div>

</template>

<script>
  import QualityReportMetric from './QualityReportMetric'
  // import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
  import { getPercentagePacketLoss, getAvgLatency, getMaxAudioLevel, getAvgFrameRate, getAvgJitter } from '@/../../shared/src/utils/twilioHelpers'

  export default {
    name: 'QualityReport',

    data () {
      return {
        chartData: [],
        line: ''
      }
    },

    components: {
      'quality-report-metric': QualityReportMetric
    },

    props: {
      reports: {
        'type': Array,
        'default': () => []
      },

      reportType: {
        'type': String,
        'default': ''
      },

      progress: {
        'type': Number,
        'default': 0
      },

      audioLevelFallback: {
        'type': Number,
        'default': 0
      },

      usersBrowserName: {
        'type': String,
        'default': ''
      }
    },

    computed: {

      latestReport () {
        return this.reports[this.reports.length - 1]
      },

      currentLatency () {
        return this.latestReport ? this.latestReport.roundTripTime : 0
      },

      currentJitter () {
        return this.latestReport ? this.latestReport.jitter : 0
      },

      avgLatency () {
        return Math.round(getAvgLatency(this.reports))
      },

      avgJitter () {
        return Math.round(getAvgJitter(this.reports))
      },

      percentagePacketLoss () {
        return Math.round(getPercentagePacketLoss(this.reports).toFixed(2)) / 100
      },

      currentPacketLoss () {
        return this.latestReport ? this.latestReport.packetsLost : 0
      },

      currentPacketsSent () {
        return this.latestReport ? this.latestReport.packetsSent : 0
      },

      currentPacketsReceived () {
        return this.latestReport ? this.latestReport.packetsReceived : 0
      },

      percentagePacketsRecieved () {
        const percent = Math.floor(100 - getPercentagePacketLoss(this.reports))
        return isNaN(percent) ? 0 : percent
      },

      currentFrameRate () {
        return this.latestReport ? this.latestReport.frameRate : 0
      },

      avgFrameRate () {
        return Math.round(getAvgFrameRate(this.reports))
      },

      currentAudioLevel () {
        return this.latestReport ? this.latestReport.audioLevel : 0
      },

      maxAudioLevel () {
        return getMaxAudioLevel(this.reports)
      }
    },

    watch: {
      progress (newVal, oldVal) {
        // if (newVal === 100) {
          this.evaluate()
        // }
      }
    },

    methods: {
      evaluate () {
        if (this.progress === 100) {

          const reports = Object.values(this.$refs).filter(metric => metric).map((metric) => metric.report())
          const failedReports = reports.filter((report) => !report.success)

          this.$emit('qualityReport', {'reportType': this.reportType, failures: failedReports})

        }

      }
    }
  }
</script>

<style scoped>

  h4{
    text-transform: capitalize;
  }

  i{
    margin-top:20px;
    font-size:3em;
  }

  svg{
    margin: 25px;
  }

  path{
    fill: none;
    stroke: #76BF8A;
    stroke-width: 3px;
  }

</style>
